import { PAGE_LEVEL } from '@/constants';

/**
 * 工作台模块路由
 */
export default {
  path: '/irmworkbench',
  children: [
    {
      path: 'index',
      name: 'irmworkbenchIndex',
      component: () => import('@/pages/irmworkbench/index.vue'),
      meta: {
        componentName: 'irmworkbenchIndex',
        pageLevel: PAGE_LEVEL.FIRST,
        name: 'common.noun.irm_workbench',
        keepAlive: true
      }
    }
  ]
};
